import { onCommonDeployError, setDeploymentRequestLoading } from "../../../basic/_fetch/_fetchHelpers";
import { createFetch } from "../../../../../helpers/fetch/FetchRequest";
import { getCookie } from "../../../../../helpers/common";
import { API_BUILDER_PROJECT_NODE } from "../../../../../settings/endpoints/stacker";
import { USER_ACCESS_TOKEN_NAME } from "../../../../../settings/global";

export function projectDelete({
                                  deploymentID,
                                  onSuccess,
                                  onError,
                              }) {

    setDeploymentRequestLoading(true);

    createFetch({
        URL: `${API_BUILDER_PROJECT_NODE}?project=${deploymentID}`,
        method: 'DELETE',
        headers: {
            'Authorization': "Bearer " + getCookie(USER_ACCESS_TOKEN_NAME),
            'Content-Type': 'application/json',
        },
        // body,
        onSuccess: response => {
            setDeploymentRequestLoading(false);
            if (onSuccess) onSuccess(response);
        },
        onError: response => {
            setDeploymentRequestLoading(false);
            if (onError) onError(response);
            onCommonDeployError(response);
        },
    });
}